import React from "react";

// 识别文本中的 https 链接并转换为可点击的 React 元素
export const convertLinksToClickable = (text: string): React.ReactNode[] => {
  // 匹配括号内的 https 链接的正则表达式
  const urlRegex = /\(((https?:\/\/[^\s)]+))\)/g;

  let lastIndex = 0;
  const result: React.ReactNode[] = [];
  let matchIndex = 0;

  // 使用 exec 来逐个匹配
  let match;
  while ((match = urlRegex.exec(text)) !== null) {
    // 添加匹配前的文本
    if (match.index > lastIndex) {
      result.push(text.slice(lastIndex, match.index));
    }

    // 添加左括号
    result.push("(");

    // 添加链接
    result.push(
      React.createElement(
        "a",
        {
          key: matchIndex++,
          href: match[1], // 使用第一个捕获组（链接URL）
          target: "_blank",
          rel: "noopener noreferrer",
          className: "underline inline",
          style: {
            wordBreak: "keep-all",
            whiteSpace: "nowrap",
            color: "#3B82F6", // 蓝色
            textDecorationColor: "#3B82F6",
          },
          onClick: (e: React.MouseEvent) => {
            e.stopPropagation(); // 防止触发父元素的点击事件
          },
          onMouseEnter: (e: React.MouseEvent) => {
            const target = e.target as HTMLElement;
            target.style.color = "#1D4ED8"; // 悬停时更深的蓝色
            target.style.textDecorationColor = "#1D4ED8";
          },
          onMouseLeave: (e: React.MouseEvent) => {
            const target = e.target as HTMLElement;
            target.style.color = "#3B82F6"; // 恢复原来的蓝色
            target.style.textDecorationColor = "#3B82F6";
          },
        },
        match[1],
      ),
    );

    // 添加右括号
    result.push(")");

    lastIndex = match.index + match[0].length;
  }

  // 添加剩余的文本
  if (lastIndex < text.length) {
    result.push(text.slice(lastIndex));
  }

  return result;
};
